import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-videoteca-invitation',
  templateUrl: './videoteca-invitation.component.html',
  styleUrls: ['./videoteca-invitation.component.scss']
})
export class VideotecaInvitationComponent implements OnInit {

  invitationId: string = '';
  isLoading: boolean = true;
  isAuthenticated: boolean = false;
  currentUser: any = null;
  videotecaInfo: any = null;
  invitationInfo: any = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    // Obtener el ID de la invitación de la URL
    this.route.params.subscribe(params => {
      this.invitationId = params['id'];
      console.log('🎯 [INVITATION] ID de invitación recibido:', this.invitationId);
      
      this.checkAuthenticationStatus();
    });
  }

  private checkAuthenticationStatus(): void {
    const userData = localStorage.getItem('currentUser');
    
    if (userData) {
      try {
        this.currentUser = JSON.parse(userData);
        this.isAuthenticated = true;
        console.log('✅ [AUTH] Usuario autenticado:', this.currentUser.email);
        this.processInvitation();
      } catch (error) {
        console.error('❌ [AUTH] Error al parsear datos de usuario:', error);
        this.redirectToLogin();
      }
    } else {
      console.log('⚠️ [AUTH] Usuario no autenticado, redirigiendo a login');
      this.redirectToLogin();
    }
  }

  private redirectToLogin(): void {
    // Guardar la URL de invitación para redirigir después del login
  localStorage.setItem('redirectAfterLogin', `/videotecas/invitations/${this.invitationId}`);
    
    Swal.fire({
      title: 'Autenticación Requerida',
      text: 'Necesitas iniciar sesión para aceptar esta invitación.',
      icon: 'info',
      confirmButtonText: 'Ir a Login',
      allowOutsideClick: false
    }).then(() => {
      this.router.navigate(['/auth/sign-in']);
    });
  }

  private async processInvitation(): Promise<void> {
    try {
      // Aceptar la invitación directamente
      await this.acceptInvitationDirect();
      
      // Si llegamos aquí, la invitación fue aceptada exitosamente
      this.showSuccessMessage();
      
    } catch (error) {
      console.error('❌ [INVITATION] Error al procesar invitación:', error);
      this.handleInvitationError(error);
    }
  }

  private acceptInvitationDirect(): Promise<any> {
    return new Promise((resolve, reject) => {
      // Construir headers de autorización
      const headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': this.currentUser.token
      });

      // Endpoint para aceptar invitación
  const endpoint = `${environment.API_URL}/videoteca/invitation/${this.invitationId}`;
      
      console.log('📤 [API] Aceptando invitación:', endpoint);

      this.http.post(endpoint, {}, { headers }).subscribe({
        next: (response: any) => {
          console.log('✅ [API] Invitación aceptada exitosamente:', response);
          this.invitationInfo = response;
          this.videotecaInfo = response.videoteca || response;
          this.isLoading = false;
          resolve(response);
        },
        error: (error) => {
          console.error('❌ [API] Error al aceptar invitación:', error);
          this.isLoading = false;
          reject(error);
        }
      });
    });
  }

  private showSuccessMessage(): void {
    const videotecaName = this.videotecaInfo?.title || this.videotecaInfo?.name || 'la videoteca';
    
    Swal.fire({
      title: '🎉 ¡Invitación Aceptada!',
      html: `
        <div style="text-align: center; margin: 20px 0;">
          <p style="font-size: 18px; color: #28a745; font-weight: bold; margin-bottom: 15px;">
            ${videotecaName}
          </p>
          <p style="color: #666;">
            Has sido agregado exitosamente a esta videoteca. 
            Ahora tienes acceso a todos sus contenidos.
          </p>
        </div>
      `,
      icon: 'success',
      confirmButtonText: 'Ir a Videoteca',
      confirmButtonColor: '#28a745'
    }).then(() => {
      // Redirigir a la videoteca
      this.router.navigate(['/Videoteca']);
    });
  }

  private showInvitationDetails(): void {
    const videotecaName = this.videotecaInfo?.title || this.videotecaInfo?.name || 'la videoteca';
    
    Swal.fire({
      title: '📚 Invitación a Videoteca',
      html: `
        <div style="text-align: left; margin: 20px 0;">
          <p><strong>Has sido invitado a:</strong></p>
          <p style="font-size: 18px; color: #2563eb; font-weight: bold;">${videotecaName}</p>
          
          <p style="margin-top: 20px;"><strong>Tu email:</strong> ${this.currentUser.email}</p>
          
          <p style="margin-top: 20px; color: #666;">
            Al aceptar esta invitación, tendrás acceso a todos los contenidos de esta videoteca.
          </p>
        </div>
      `,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: '✅ Aceptar Invitación',
      cancelButtonText: '❌ Rechazar',
      confirmButtonColor: '#28a745',
      cancelButtonColor: '#dc3545'
    }).then((result) => {
      if (result.isConfirmed) {
        this.acceptInvitation();
      } else {
        this.declineInvitation();
      }
    });
  }

  public acceptInvitation(): void {
    Swal.fire({
      title: 'Aceptando invitación...',
      text: 'Por favor espere mientras procesamos su solicitud.',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'Authorization': this.currentUser.token
    });

  const endpoint = `${environment.API_URL}/videoteca/invitation/${this.invitationId}`;
    
    console.log('📤 [API] Aceptando invitación:', endpoint);

    this.http.post(endpoint, {}, { headers }).subscribe({
      next: (response: any) => {
        console.log('✅ [SUCCESS] Invitación aceptada:', response);
        
        Swal.fire({
          title: '🎉 ¡Invitación Aceptada!',
          text: `Ahora tienes acceso a ${this.videotecaInfo?.title || 'la videoteca'}. Serás redirigido automáticamente.`,
          icon: 'success',
          confirmButtonText: 'Ir a Videoteca',
          confirmButtonColor: '#28a745'
        }).then(() => {
          // Redirigir a la videoteca
          this.router.navigate(['/Videoteca']);
        });
      },
      error: (error) => {
        console.error('❌ [ERROR] Error al aceptar invitación:', error);
        
        let errorMessage = 'Hubo un problema al aceptar la invitación. Intenta de nuevo.';
        
        if (error.status === 409) {
          errorMessage = 'Ya tienes acceso a esta videoteca.';
        } else if (error.status === 404) {
          errorMessage = 'La invitación no existe o ha expirado.';
        } else if (error.error?.message) {
          errorMessage = error.error.message;
        }

        Swal.fire({
          title: 'Error',
          text: errorMessage,
          icon: 'error',
          confirmButtonText: 'Entendido'
        });
      }
    });
  }

  public declineInvitation(): void {
    Swal.fire({
      title: 'Invitación Rechazada',
      text: 'Has rechazado la invitación a la videoteca.',
      icon: 'info',
      confirmButtonText: 'Ir al Dashboard'
    }).then(() => {
      this.router.navigate(['/dashboard']);
    });
  }

  public goToDashboard(): void {
    this.router.navigate(['/dashboard']);
  }

  private handleInvitationError(error: any): void {
    let errorTitle = 'Error de Invitación';
    let errorMessage = 'No se pudo procesar la invitación.';

    if (error.status === 404) {
      errorTitle = 'Invitación No Encontrada';
      errorMessage = 'La invitación no existe, ha expirado o ya fue utilizada.';
    } else if (error.status === 403) {
      errorTitle = 'Acceso Denegado';
      errorMessage = 'No tienes permisos para acceder a esta invitación.';
    } else if (error.status === 401) {
      errorTitle = 'No Autorizado';
      errorMessage = 'Tu sesión ha expirado. Por favor, inicia sesión nuevamente.';
    }

    Swal.fire({
      title: errorTitle,
      text: errorMessage,
      icon: 'error',
      confirmButtonText: 'Entendido'
    }).then(() => {
      if (error.status === 401) {
        this.router.navigate(['/auth/sign-in']);
      } else {
        this.router.navigate(['/dashboard']);
      }
    });
  }
}